import sketch_girl from "../assets/sketch_girl.jpg";
import color_pencil from "../assets/color_pencil.jpg";
import watercolor from "../assets/watercolor.jpg";
import digital from "../assets/digital.jpg";
import pen_art from "../assets/pen_art.jpg";
import painting from "../assets/painting.jpg";

export const MenuList = [
  {
    name: "Graphite Pencil Portrait",
    image: sketch_girl,
    price: 1000,
  },
  {
    name: "Color Pencil Portrait",
    image: color_pencil,
    price: 1500,
  },
  {
    name: "Water Color Portrait",
    image: watercolor,
    price: 2000,
  },
  {
    name: "Digital Art",
    image: digital,
    price: 2500,
  },
  {
    name: "Painting",
    image: painting,
    price: 3000,
  },
  {
    name: "Pen Sketch",
    image: pen_art,
    price: 2000,
  },
];
